module.exports = __webpack_public_path__ + "static/media/REPORT-COUNT-5.f7e7f532.png";